import { FC } from 'react';
import styles from './HouseSubscriptionBanner.css';
import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import { IHouseSubscriptionBannerProps } from '../../types';

export const HouseSubscriptionBanner: FC<IHouseSubscriptionBannerProps> = ({
  title,
  subtitle,
  buttonText,
  onClick,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['inner']}>
        <div className={styles['title']}>
          <UIHeading1>{title}</UIHeading1>
        </div>
        <div className={styles['subtitle']}>
          <UIText1>{subtitle}</UIText1>
        </div>
        <Button size="M" theme="fill_primary" onClick={onClick}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
